var ils;
(function (ils) {
    class PreferredMoveInType {
        constructor(item) {
            if (!item) {
                item = {};
            }
            // Copy the contents of the passed in item using the native javascript `Object.assign(dest, source)`
            Object.assign(this, item);
        }
    }
    ils.PreferredMoveInType = PreferredMoveInType;
})(ils || (ils = {}));

var ils;
(function (ils) {
    let showcase;
    (function (showcase) {
        let FormType;
        (function (FormType) {
            FormType["GetMoreInfo"] = "Get More Info";
            FormType["CheckAvailability"] = "Check Availability";
            FormType["ScheduleTour"] = "Schedule a Tour";
            FormType["ApplyNow"] = "Apply Now";
        })(FormType = showcase.FormType || (showcase.FormType = {}));
        let ViewType;
        (function (ViewType) {
            ViewType["NameInfo"] = "Name Info";
            ViewType["ContactInfo"] = "Contact Info";
            ViewType["TourDate"] = "Tour Date";
            ViewType["FloorPlans"] = "Floor Plans";
            ViewType["RoommatesQuestion"] = "Roommates Question";
            ViewType["Roommates"] = "List of Roommates";
            ViewType["Comments"] = "Move-in Date and Comments";
        })(ViewType = showcase.ViewType || (showcase.ViewType = {}));
    })(showcase = ils.showcase || (ils.showcase = {}));
    class ProgressStep {
        constructor(stepName, parentForms, order, isComplete) {
            this.StepName = ko.observable(stepName);
            this.IsComplete = ko.observable(isComplete);
            this.ParentForms = parentForms;
            this.Order = ko.observable(order);
            this.ForceHide = ko.observable(false);
            this.ForceShow = ko.observable(false);
            this.IsVisible = (formType, showRoommates, hasRoommates) => {
                if (this.ForceShow()) {
                    return true;
                }
                if (this.ForceHide()) {
                    return false;
                }
                if (this.StepName() === showcase.ViewType.RoommatesQuestion) {
                    return showRoommates && this.ParentForms.some(pf => pf === formType);
                }
                if (this.StepName() === showcase.ViewType.Roommates) {
                    return showRoommates && hasRoommates && this.ParentForms.some(pf => pf === formType);
                }
                return this.ParentForms.some(pf => pf === formType);
            };
            this.StepTiming = new ils.PageTiming(stepName);
            this.ForceHide.subscribe((newVal) => {
                if (newVal === true) {
                    this.ForceShow(false);
                }
            }, this);
            this.ForceShow.subscribe((newVal) => {
                if (newVal === true) {
                    this.ForceHide(false);
                }
            }, this);
        }
    }
    ils.ProgressStep = ProgressStep;
    class LeadFormStepManager {
        constructor(item = {}) {
            var _a, _b;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////
            // This is basically our state machine to manage the state on each step. The way we navigate the form
            // depends on the type of form we're in (i.e. 'Get More Info, 'Schedule a Tour', 'Check Availability', or
            // 'Apply Now').
            // This means we have to set the 'Next' and 'Back' buttons based on the type of form we're in and the 
            // responses of the user to some of those answers (i.e. 'Do you have roommates?').
            ///////////////////////////////////////////////////////////////////////////////////////////////////////
            this.setFormState = (newVal) => {
                if (!newVal) {
                    return;
                }
                this.StartTrackingForNewStep(newVal);
                let activeIndex = this.ActiveViews().findIndex((val, idx, steps) => { return val.StepName() === newVal; });
                this.BackStepVisible(activeIndex > 0);
                this.SubmitButtonText(activeIndex === this.ActiveViews().length - 1
                    ? this.FormType() === showcase.FormType.ApplyNow
                        ? "Continue to Application"
                        : "Submit"
                    : "Next");
                switch (newVal) {
                    case showcase.ViewType.NameInfo:
                        this.MainText(`${this.CommunityName()}`);
                        if (this.FormType() == showcase.FormType.GetMoreInfo) {
                            this.Pretext("Let's introduce you to");
                        }
                        else if (this.FormType() == showcase.FormType.CheckAvailability) {
                            this.Pretext("Let's check availability at");
                        }
                        else if (this.FormType() == showcase.FormType.ScheduleTour) {
                            this.Pretext("Let's schedule your tour at");
                        }
                        else if (this.FormType() === showcase.FormType.ApplyNow) {
                            this.Pretext("Get started on your application for");
                        }
                        break;
                    case showcase.ViewType.TourDate:
                        this.Pretext("Tour Request");
                        this.MainText("What date and time works best for you?");
                        break;
                    case showcase.ViewType.ContactInfo:
                        this.Pretext(this.ActiveView());
                        this.MainText("How can they reach out?");
                        break;
                    case showcase.ViewType.RoommatesQuestion:
                        this.Pretext(`${this.CommunityName()} is a "by the room" student community`);
                        this.MainText("Have you thought about roommates?");
                        break;
                    case showcase.ViewType.Roommates:
                        this.Pretext(`${this.CommunityName()} is a "by the room" student community`);
                        this.MainText("Who are your roommates?");
                        break;
                    case showcase.ViewType.FloorPlans:
                        this.Pretext(this.ActiveView());
                        this.MainText("Which floor plan(s) interest you?");
                        break;
                    case showcase.ViewType.Comments:
                        this.Pretext(this.ActiveView());
                        this.MainText("Anything we can pass along to the team?");
                        break;
                    default:
                        break;
                }
            };
            this.ActiveView = !item.ActiveView ? ko.observable(showcase.ViewType.NameInfo) : ko.observable(item.ActiveView);
            this.FormType = !item.FormType ? ko.observable(showcase.FormType.GetMoreInfo) : ko.observable(item.FormType);
            this.SubmitButtonText = ko.observable("Next");
            this.BackStepVisible = ko.observable(false);
            this.JustMe = !item.JustMe ? ko.observable(false) : ko.observable(item.JustMe);
            this.HasRoommates = !item.HasRoommates ? ko.observable(false) : ko.observable(item.HasRoommates);
            this.NeedRoommate = !item.NeedRoommate ? ko.observable(false) : ko.observable(item.NeedRoommate);
            this.ShowRoommates = !item.ShowRoommatesOption ? ko.observable(false) : ko.observable(item.ShowRoommatesOption);
            this.Pretext = ko.observable("Let's introduce you to");
            this.MainText = ko.observable(`${((_a = item.CommunityName) !== null && _a !== void 0 ? _a : "")}`);
            this.CommunityName = ko.observable((_b = item.CommunityName) !== null && _b !== void 0 ? _b : "");
            this.ProgressSteps = ko.observableArray([]);
            this.HasRoommateQuestionError = ko.observable(false);
            this.HasStartedForm = ko.observable(false);
            let isActiveSorting = false;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////
            // This is setting up all the possible steps we can take in the form. This is part of how we manage
            // state as well as what actions to take on a step. The Order() value of each step is two more than 
            // the previous one so that we have the ability to easily change the order of the steps inside an A/B
            // test using Google Optimize via running some Javascript when the A/B test loads.
            ////////////////////////////////////////////////////////////////////////////////////////////////////////
            const progressSteps = [];
            for (let val in showcase.ViewType) {
                let parentForms = [];
                let value = showcase.ViewType[val];
                if (value == showcase.ViewType.NameInfo) {
                    parentForms.push(showcase.FormType.GetMoreInfo);
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    parentForms.push(showcase.FormType.ApplyNow);
                    progressSteps.push(new ProgressStep(value, parentForms, 1, true));
                    continue;
                }
                if (value == showcase.ViewType.TourDate) {
                    parentForms.push(showcase.FormType.ScheduleTour);
                    progressSteps.push(new ProgressStep(value, parentForms, 3, false));
                    continue;
                }
                if (value == showcase.ViewType.ContactInfo) {
                    parentForms.push(showcase.FormType.GetMoreInfo);
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    parentForms.push(showcase.FormType.ApplyNow);
                    progressSteps.push(new ProgressStep(value, parentForms, 5, false));
                    continue;
                }
                // Combining the Roommates steps to not overwhelm the user with the progress bar
                if (value === showcase.ViewType.RoommatesQuestion || value === showcase.ViewType.Roommates) {
                    if (this.ShowRoommates()) {
                        parentForms.push(showcase.FormType.GetMoreInfo);
                        parentForms.push(showcase.FormType.ScheduleTour);
                        parentForms.push(showcase.FormType.CheckAvailability);
                        let step = new ProgressStep(value, parentForms, value === showcase.ViewType.RoommatesQuestion ? 7 : 8, false);
                        step.ForceHide(value === showcase.ViewType.Roommates);
                        progressSteps.push(step);
                    }
                    continue;
                }
                if (value == showcase.ViewType.FloorPlans) {
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    progressSteps.push(new ProgressStep(value, parentForms, 10, false));
                    continue;
                }
                if (value == showcase.ViewType.Comments) {
                    parentForms.push(showcase.FormType.GetMoreInfo);
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    progressSteps.push(new ProgressStep(value, parentForms, 12, false));
                    continue;
                }
            }
            this.ProgressSteps.push(...progressSteps.sort((l, r) => { return l.Order() < r.Order() ? -1 : 1; }));
            // Subscribe to the Order() property of each step so that if it's changed we re-sort the overall ProgressSteps array
            this.ProgressSteps().forEach((val, idx, steps) => {
                val.Order.subscribe((newVal) => {
                    if (isActiveSorting) {
                        return;
                    }
                    isActiveSorting = true;
                    this.ProgressSteps.sort((l, r) => {
                        return l.Order() < r.Order() ? -1 : 1;
                    });
                    this.ProgressSteps().forEach((val, idx, steps) => {
                        if (idx === 0) {
                            val.Order(idx + 1);
                            return;
                        }
                        val.Order(steps[idx - 1].Order() + 2);
                    });
                    isActiveSorting = false;
                });
            });
            this.ShowApplicationLinkButton = ko.pureComputed(() => {
                return this.ActiveStep().StepName() === showcase.ViewType.ContactInfo && this.FormType() === showcase.FormType.ApplyNow;
            });
            this.ProgressSteps.subscribe((arrayChangeVal) => {
                this.ActiveView(this.ActiveViews()[0].StepName());
                this.ProgressSteps().forEach((val, idx, steps) => {
                    val.IsComplete(val.StepName() === this.ActiveViews()[0].StepName());
                }, this);
            }, this, "arrayChange");
            this.ActiveViews = ko.pureComputed(() => {
                return this.ProgressSteps().filter((val, idx, steps) => {
                    return val.IsVisible(this.FormType(), this.ShowRoommates(), this.HasRoommates());
                }).sort((l, r) => { return l.Order() < r.Order() ? -1 : 1; });
            }, this);
            this.ActiveStep = ko.pureComputed(() => {
                return this.ProgressSteps().find((val, idx, steps) => {
                    return val.StepName() == this.ActiveView();
                });
            }, this);
            this.NextStep = ko.pureComputed(() => {
                for (let i = 0; i < this.ActiveViews().length; i++) {
                    let val = this.ActiveViews()[i];
                    if (!val || !val.IsVisible(this.FormType(), this.ShowRoommates(), this.HasRoommates())) {
                        continue;
                    }
                    if (val.Order() > this.ActiveStep().Order()) {
                        return val.StepName();
                    }
                }
                return this.ActiveView();
            }, this);
            this.BackStep = ko.pureComputed(() => {
                for (let i = this.ActiveViews().length - 1; i >= 0; i--) {
                    let val = this.ActiveViews()[i];
                    if (!val || !val.IsVisible(this.FormType(), this.ShowRoommates(), this.HasRoommates())) {
                        continue;
                    }
                    if (val.Order() < this.ActiveStep().Order()) {
                        return val.StepName();
                    }
                }
                return this.ActiveView();
            }, this);
            this.IconHtml = ko.pureComputed(() => {
                let html = [];
                switch (this.FormType()) {
                    case showcase.FormType.GetMoreInfo:
                        const getMoreInfoIcons = [
                            `<span class="ilsicon ilsicon-faq-bubble"></span>`
                        ];
                        html.push(...getMoreInfoIcons);
                        break;
                    case showcase.FormType.ScheduleTour:
                        const scheduleTourIcons = [
                            `<span class="ilsicon-stack">`,
                            `   <span class="ilsicon ilsicon-calendar-p3 third"></span><span class="ilsicon ilsicon-calendar brand-primary"></span><span class="ilsicon ilsicon-calendar-p2 brand-secondary"></span>`,
                            `</span>`
                        ];
                        html.push(...scheduleTourIcons);
                        break;
                    case showcase.FormType.CheckAvailability:
                        const checkAvailabilityIcons = [
                            `<span class="ilsicon-stack">`,
                            `   <span class="ilsicon ilsicon-magnify-p3 third"></span><span class="ilsicon ilsicon-magnify-p1 brand-primary"></span><span class="ilsicon ilsicon-magnify-p2 brand-secondary"></span>`,
                            `</span>`
                        ];
                        html.push(...checkAvailabilityIcons);
                        break;
                    case showcase.FormType.ApplyNow:
                        const applyNowIcons = [
                            `<span class="ilsicon ilsicon-renters"></span>`
                        ];
                        html.push(...applyNowIcons);
                        break;
                    default:
                        const defaultIcons = [
                            `<span class="ilsicon ilsicon-faq-bubble"></span>`
                        ];
                        html.push(...defaultIcons);
                        break;
                }
                return html.join('');
            }, this);
            this.ActiveView.subscribe((newVal) => {
                this.setFormState(newVal);
            });
            this.FormType.subscribe((newVal) => {
                if (this.ActiveView() == this.ActiveViews()[0].StepName()) {
                    this.setFormState(this.ActiveViews()[0].StepName());
                }
                else {
                    this.ActiveView(this.ActiveViews()[0].StepName());
                }
                const activeStepIndex = this.ProgressSteps().findIndex((val, idx, allSteps) => {
                    return val.StepName() == this.ActiveView();
                });
                this.ProgressSteps().forEach((val, idx, allSteps) => {
                    if (activeStepIndex < 0) {
                        val.IsComplete(false);
                        return;
                    }
                    if (val.Order() > allSteps[activeStepIndex].Order()) {
                        val.IsComplete(false);
                    }
                    else {
                        val.IsComplete(true);
                    }
                });
            });
            this.NavigateToNextStep = () => {
                this.ProgressSteps().forEach((val, idx, steps) => {
                    if (val.StepName() === this.NextStep()) {
                        val.IsComplete(true);
                    }
                }, this);
                if (this.SubmitButtonText() === "Submit" || this.SubmitButtonText() === "Continue to Application") {
                    // Submit the form
                    ils.viewModel.ReadyToSubmit(true);
                    return;
                }
                this.ActiveView(this.NextStep());
            };
            this.NavigateBackOneStep = () => {
                this.ProgressSteps().forEach((val, dx, steps) => {
                    if (val.StepName() === this.ActiveView()) {
                        val.IsComplete(false);
                    }
                });
                this.ActiveView(this.BackStep());
            };
            this.FormClass = ko.pureComputed(() => {
                switch (this.ActiveView()) {
                    case showcase.ViewType.NameInfo:
                        return "c-guest-card-element__form c-guest-card-element__form--name";
                    case showcase.ViewType.TourDate:
                        return "c-guest-card-element__form c-guest-card-element__form--tour";
                    case showcase.ViewType.ContactInfo:
                        return "c-guest-card-element__form c-guest-card-element__form--contact";
                    case showcase.ViewType.Comments:
                        return "c-guest-card-element__form c-guest-card-element__form--comments";
                    case showcase.ViewType.Roommates:
                    case showcase.ViewType.RoommatesQuestion:
                        return "c-guest-card-element__form c-guest-card-element__form--roommates";
                    default:
                        return "c-guest-card-element__form";
                }
            });
            this.NavigateTo = (progressStep) => {
                for (let val in showcase.ViewType) {
                    let value = showcase.ViewType[val];
                    if (value == progressStep.StepName()) {
                        this.ActiveView(value);
                        return;
                    }
                }
            };
            this.TurnOnStepTimeTracking = (isFormActive) => {
                const activeIndex = this.ProgressSteps().findIndex((val, idx, steps) => {
                    return val.StepName() === this.ActiveView();
                });
                if (activeIndex < 0) {
                    this.ProgressSteps().forEach((val, idx, steps) => {
                        val.StepTiming.stopTracking();
                    });
                    return;
                }
                let activeStep = this.ProgressSteps()[activeIndex];
                if (!isFormActive) {
                    activeStep.StepTiming.stopTracking();
                }
                else {
                    activeStep.StepTiming.startTracking();
                }
            };
            this.StartTrackingForNewStep = (stepName) => {
                this.ProgressSteps().forEach((val, idx, steps) => {
                    if (val.StepTiming.isCurrentlyTracking()) {
                        val.StepTiming.stopTracking();
                        if (!ils.isSiteLive) {
                            console.log(`Current total time tracked for ${val.StepTiming.name} so far is ${val.StepTiming.timeDuration}.`);
                        }
                    }
                });
                const activeIndex = this.ProgressSteps().findIndex((val, idx, steps) => {
                    return val.StepName() === stepName;
                });
                if (activeIndex < 0) {
                    return;
                }
                let activeStep = this.ProgressSteps()[activeIndex];
                activeStep.StepTiming.startTracking();
            };
            this.SendFormCompletionMetrics = (submitHasBeenClicked) => {
                gaSendStepFormCompletion(submitHasBeenClicked, this.HasStartedForm(), this.FormType(), this.ActiveView());
            };
            this.ContactStepErrors = null;
        }
    }
    ils.LeadFormStepManager = LeadFormStepManager;
})(ils || (ils = {}));

var ils;
(function (ils) {
    class ProspectFormData {
        constructor(item = {}) {
            this.PrimaryGuest = !item.PrimaryGuest ? new ils.GuestCardInfo() : item.PrimaryGuest;
            this.Roommates = !item.Roommates ? ko.observableArray([]) : ko.observableArray(item.Roommates);
            this.ContactTypeID = !item.ContactTypeID ? ko.observable(1) : ko.observable(item.ContactTypeID);
            this.MoveInMonth = !item.MoveInMonth ? ko.observable() : ko.observable(item.MoveInMonth);
            this.MoveInDay = !item.MoveInDay ? ko.observable() : ko.observable(item.MoveInDay);
            this.SelectedFloorPlans = !item.SelectedFloorPlans ? ko.observableArray([]) : ko.observableArray(item.SelectedFloorPlans);
            this.SubmitHasBeenClicked = ko.observable(false);
            this.RemovedRoommates = ko.observableArray([]);
            this.DateOfVisit = ko.observable(null);
            this.StepManager = new ils.LeadFormStepManager({
                CommunityName: item.CommunityName,
                JustMe: item.JustMe,
                HasRoommates: item.HasRoommates,
                NeedRoommate: item.NeedRoommate,
                ShowRoommatesOption: item.ShowRoommatesOption,
                FormType: !item.ContactTypeID
                    ? ils.showcase.FormType.GetMoreInfo
                    : item.ContactTypeID == 1
                        ? ils.showcase.FormType.GetMoreInfo
                        : item.ContactTypeID == 2
                            ? ils.showcase.FormType.ScheduleTour
                            : item.ContactTypeID == 3
                                ? ils.showcase.FormType.CheckAvailability
                                : ils.showcase.FormType.GetMoreInfo
            });
            this.PrimaryGuestErrors = ko.validation.group(this.PrimaryGuest);
            this.RoommatesErrors = ko.validation.group(this.Roommates, {
                deep: true,
                live: true
            });
            this.HasErrors = ko.computed(() => {
                return this.PrimaryGuestErrors().length > 0 && this.SubmitHasBeenClicked();
            });
            this.IsFormValid = () => {
                this.PrimaryGuestErrors.showAllMessages();
                let hasErrors = this.HasErrors();
                if (this.StepManager.HasRoommates()) {
                    this.RoommatesErrors.showAllMessages();
                    hasErrors = hasErrors || (this.RoommatesErrors().length > 0 && this.SubmitHasBeenClicked());
                }
                return !hasErrors;
            };
            this.StepManager.HasRoommates.subscribe((newVal) => {
                if (!newVal) {
                    return;
                }
                if (newVal === true) {
                    this.StepManager.HasRoommateQuestionError(false);
                    this.StepManager.JustMe(false);
                }
                if (this.Roommates().length < 1) {
                    this.AddRoommate();
                }
            });
            this.StepManager.NeedRoommate.subscribe((newVal) => {
                if (newVal === true) {
                    this.StepManager.HasRoommateQuestionError(false);
                    this.StepManager.JustMe(false);
                }
            });
            this.StepManager.JustMe.subscribe((newVal) => {
                if (newVal === true) {
                    this.StepManager.HasRoommateQuestionError(false);
                    this.StepManager.HasRoommates(false);
                    this.StepManager.NeedRoommate(false);
                }
            });
            this.AddRoommate = () => {
                var nextOrder = this.Roommates().length + 1;
                if (this.RemovedRoommates().length > 0) {
                    var removedRoommate = this.RemovedRoommates.pop();
                    removedRoommate.RoommateOrder(nextOrder);
                    this.Roommates.push(removedRoommate);
                    return;
                }
                const newRoommate = new ils.Roommate({
                    GuestInfo: new ils.GuestCardInfo({ RequireEmailOrPhone: false }),
                    RoommateOrder: nextOrder
                });
                this.Roommates.push(newRoommate);
            };
            this.RemoveRoommate = (RoommateLocalId) => {
                const removedItems = this.Roommates.remove((rm) => {
                    return rm.RoommateLocalId() == RoommateLocalId;
                });
                const removed = removedItems[0];
                this.RemovedRoommates.push(removed);
                if (this.Roommates().length < 1) {
                    this.StepManager.HasRoommates(false);
                    return;
                }
                for (var i = 0; i < this.Roommates().length; i++) {
                    this.Roommates()[i].RoommateOrder(i + 1);
                }
            };
            this.ContactTypeID.subscribe((newVal) => {
                const formType = !newVal
                    ? ils.showcase.FormType.GetMoreInfo
                    : newVal == 1
                        ? ils.showcase.FormType.GetMoreInfo
                        : newVal == 2
                            ? ils.showcase.FormType.ScheduleTour
                            : newVal == 3
                                ? ils.showcase.FormType.CheckAvailability
                                : newVal === 5
                                    ? ils.showcase.FormType.ApplyNow
                                    : ils.showcase.FormType.GetMoreInfo;
                this.StepManager.FormType(formType);
            });
            this.StepManager.ContactStepErrors = ko.validation.group([this.PrimaryGuest.Email, this.PrimaryGuest.Phone]);
            this.OnNext = () => {
                let isStepValid = false;
                switch (this.StepManager.ActiveView()) {
                    case ils.showcase.ViewType.NameInfo:
                        this.StepManager.HasStartedForm(true);
                        this.PrimaryGuest.EnableGuestValidation(true);
                        let guestNameErrors = ko.validation.group(this.PrimaryGuest.GuestName);
                        const guestNameValid = ko.validation.validateObservable(this.PrimaryGuest.GuestName);
                        guestNameErrors.showAllMessages();
                        isStepValid = guestNameValid;
                        this.PrimaryGuest.EnableGuestValidation(!isStepValid);
                        break;
                    case ils.showcase.ViewType.TourDate:
                        isStepValid = true;
                        break;
                    case ils.showcase.ViewType.ContactInfo:
                        this.PrimaryGuest.EnableGuestValidation(true);
                        this.StepManager.ContactStepErrors.showAllMessages();
                        const isValid = this.StepManager.ContactStepErrors().length < 1;
                        isStepValid = isValid;
                        this.PrimaryGuest.EnableGuestValidation(!isStepValid);
                        break;
                    case ils.showcase.ViewType.RoommatesQuestion:
                        if (!this.StepManager.JustMe() && !this.StepManager.HasRoommates() && !this.StepManager.NeedRoommate()) {
                            // Show the error message
                            this.StepManager.HasRoommateQuestionError(true);
                            isStepValid = false;
                        }
                        else {
                            this.StepManager.HasRoommateQuestionError(false);
                            isStepValid = true;
                            if (this.StepManager.HasRoommates()) {
                                this.StepManager.ProgressSteps().forEach((val, idx, steps) => {
                                    if (val.StepName() === ils.showcase.ViewType.Roommates) {
                                        val.ForceShow(true);
                                    }
                                });
                                this.Roommates().forEach((val, idx, allRoommates) => {
                                    val.GuestInfo.EnableGuestValidation(false);
                                });
                            }
                            else {
                                this.StepManager.ProgressSteps().forEach((val, idx, steps) => {
                                    if (val.StepName() === ils.showcase.ViewType.Roommates) {
                                        val.ForceHide(true);
                                    }
                                });
                            }
                        }
                        break;
                    case ils.showcase.ViewType.Roommates:
                        let indexesToRemove = [];
                        for (let i = this.Roommates().length - 1; i > -1; i--) {
                            let val = this.Roommates()[i];
                            // We don't validate against completely blank roommates so we will remove them from the list of roommates
                            if (!val.GuestInfo.GuestName() && !val.GuestInfo.Email() && !val.GuestInfo.Phone()) {
                                indexesToRemove.push(i);
                                this.Roommates.remove(val);
                                continue;
                            }
                            // otherwise we go ahead and enable the validation on the roommate entered
                            val.GuestInfo.EnableGuestValidation(true);
                        }
                        if (this.Roommates().length < 1) {
                            this.StepManager.HasRoommates(false);
                            this.StepManager.JustMe(true);
                            isStepValid = true;
                            this.StepManager.ProgressSteps().forEach((val, idx, steps) => {
                                if (val.StepName() === ils.showcase.ViewType.Roommates) {
                                    val.ForceHide(true);
                                }
                            });
                            break;
                        }
                        this.RoommatesErrors.showAllMessages();
                        isStepValid = this.RoommatesErrors().length < 1;
                        break;
                    default:
                        isStepValid = true;
                        break;
                }
                if (isStepValid) {
                    this.StepManager.NavigateToNextStep();
                }
            };
            this.OnBack = () => {
                switch (this.StepManager.ActiveView()) {
                    case ils.showcase.ViewType.ContactInfo:
                        this.PrimaryGuest.EnableGuestValidation(false);
                        break;
                    case ils.showcase.ViewType.Roommates:
                        this.Roommates().forEach((val, idx, allRoommates) => {
                            val.GuestInfo.EnableGuestValidation(false);
                        });
                        break;
                    default:
                        break;
                }
                this.StepManager.NavigateBackOneStep();
            };
            this.NavigateStepTo = (progressStep) => {
                if (!progressStep.IsComplete()) {
                    return;
                }
                this.StepManager.NavigateTo(progressStep);
                const activeStepIndex = this.StepManager.ProgressSteps().findIndex((val, idx, allSteps) => {
                    return val.StepName() == this.StepManager.ActiveView();
                });
                this.StepManager.ProgressSteps().forEach((val, idx, allSteps) => {
                    if (activeStepIndex < 0) {
                        val.IsComplete(false);
                        return;
                    }
                    if (val.Order() > allSteps[activeStepIndex].Order()) {
                        val.IsComplete(false);
                    }
                });
            };
        }
    }
    ils.ProspectFormData = ProspectFormData;
})(ils || (ils = {}));

var ils;
(function (ils) {
    class FloorPlanInfo {
        constructor(item) {
            if (!item) {
                item = {};
            }
            // Copy the contents of the passed in item using the native javascript `Object.assign(dest, source)`
            Object.assign(this, item);
            // Set the remaining values based on more detailed logic
            this.ImageUrl = this.Image && this.Image != '' ? (this.Image && this.Image.toLowerCase().indexOf('http') == -1 ? imageDomain + "uploads/floorplans/" : "") + this.Image : 'missing.jpg';
            this.ImageSrc = (this.ImageUrl && this.ImageUrl.toLowerCase().indexOf('http') == -1 ? (this.ImageUrl + "?preset=floorplan&404=floorplan") : imageDomain + "external-resizer.aspx?width=220&height=245&scale=both&404=floorplan&filename=" + this.ImageUrl);
            this.NumberBedroomsText = this.NumberBedrooms > 0 ? this.NumberBedrooms + "-bedroom" : "Studio";
            this.NumberBedroomsLongText = this.NumberBedrooms > 0 ? this.NumberBedrooms + " Bedroom" + (this.NumberBedrooms > 1 ? "s" : "") : "Studio";
            this.Pricing = this.Price == 0 ? "Please call for details" : ils.AddCommas(this.Price) + ' per ' + (this.PriceByUnit ? 'Month' : 'Room');
            this.PriceChangeExtra = this.PriceChange == 0 ? "" : "The price of this floor plan has gone " + (this.PriceChange > 0 ? "up " : "down ") + Math.abs(this.PriceChange * 100).toFixed(0) + "% in the last week. Call today and ask how you can lock in the current rate.";
            this.Specials = item.Specials;
            this.Details = ko.computed(() => {
                if (this.Specials) {
                    var specialsSplit = this.Specials.split('\n');
                    if (specialsSplit.length > 1 && specialsSplit[0].length < 1 && specialsSplit[1].length > 0) {
                        return specialsSplit[1].split('\n');
                    }
                    return this.Specials.split('\n');
                }
                return [];
            });
            this.HasDetails = ko.computed(() => {
                return this.Details().length > 0;
            });
            this.HasMorePhotos = ko.computed(() => {
                return $(`.media-items [data-additional-galleries*=${this.FloorPlanID}]`).length > 0;
            });
            this.HasMoreVirtualTours = ko.computed(() => {
                return $(`.media-items [data-floorplan-virtual-tour*=${this.FloorPlanID}]`).length > 0;
            });
            this.HasMorePhotoText = ko.computed(() => {
                return !this.HasMorePhotos() && !this.HasMoreVirtualTours()
                    ? ""
                    : this.HasMoreVirtualTours()
                        ? `<span class="glyphicon glyphicon-play-circle"></span><span class="label-text">&nbsp;3Dx Virtual Tour</span>`
                        //? `<span class="ilsicon ilsicon-results">&nbsp;3Dx Virtual Tour</span>`
                        : `<span class="ilsicon ilsicon-results"></span>&nbsp;More Photos`;
            });
            this.InitialFloorPlanCarouselImage = ko.computed(() => {
                return this.ImageUrl;
                // The code below works but the VirtualTourUrl is used as an image when the overlay is launched which
                // won't work since it's a URL to an iFrame.
                //return this.HasMoreVirtualTours() && this.VirtualTourUrl
                //    ? this.VirtualTourUrl
                //    : this.ImageUrl;
            });
        }
    }
    ils.FloorPlanInfo = FloorPlanInfo;
})(ils || (ils = {}));

var ils;
(function (ils) {
    var iLSHelpers = Helpers;
    class GuestCardInfo {
        constructor(item) {
            if (!item) {
                item = {};
            }
            this.FirstName = (typeof (item.FirstName) == "undefined" ? ko.observable(null) : ko.observable(item.FirstName));
            this.LastName = (typeof (item.LastName) == "undefined" ? ko.observable(null) : ko.observable(item.LastName));
            this.Email = (typeof (item.Email) == "undefined" ? ko.observable(null) : ko.observable(item.Email));
            this.Phone = (typeof (item.Phone) == "undefined" ? ko.observable(null) : ko.observable(item.Phone));
            this.MoveInDate = typeof (item.MoveInDate) == "undefined" ? ko.observable(null) : ko.observable(item.MoveInDate);
            this.RenterCommentsAndQuestions = typeof (item.RenterCommentsAndQuestions) == "undefined" ? ko.observable(null) : ko.observable(item.RenterCommentsAndQuestions);
            this.GuestName = !this.FirstName() && !this.LastName() ? ko.observable(null) : ko.observable(`${this.FirstName()} ${this.LastName()}`);
            this.EnableGuestValidation = ko.observable(false);
            this.RequireEmailOrPhone = typeof (item.RequireEmailOrPhone) == "undefined" ? ko.observable(true) : ko.observable(item.RequireEmailOrPhone);
            this.cdpSessionId = ils.cdpSessionId;
            this.MissingEmailAndPhone = () => {
                const emailAddress = this.Email();
                const phoneNumber = this.Phone();
                const isMissingPhoneAndEmail = !ko.validation.rules.required.validator(emailAddress, true) && !ko.validation.rules.required.validator(phoneNumber, true);
                return isMissingPhoneAndEmail;
            };
            // Setup Validation
            this.FirstName.extend({
                required: {
                    message: "First Name is Required"
                },
                maxLength: 50
            });
            this.LastName.extend({
                required: {
                    message: "Last Name is Required"
                },
                maxLength: 50
            });
            this.Email.extend({
                required: {
                    message: "Please enter an Email and/or Phone Number",
                    onlyIf: () => {
                        return this.MissingEmailAndPhone() && this.RequireEmailOrPhone();
                    }
                },
                email: {
                    onlyIf: () => {
                        return this.EnableGuestValidation();
                    }
                },
                maxLength: 382
            });
            this.Phone.extend({
                required: {
                    message: "Please enter a Phone Number and/or Email",
                    onlyIf: () => {
                        this.MissingEmailAndPhone() && this.RequireEmailOrPhone();
                    }
                },
                phoneiLS: {
                    onlyIf: () => {
                        return this.EnableGuestValidation() && this.Phone() !== null && this.Phone().trim().length > 0;
                    }
                }
            });
            this.RenterCommentsAndQuestions.extend({
                maxLength: 500
            });
            this.GuestName.extend({
                required: {
                    message: "Please enter a full name.",
                    onlyIf: () => {
                        return !ils.viewModel
                            ? false
                            : true;
                    }
                },
                fullNameiLS: {
                    onlyIf: () => {
                        return this.EnableGuestValidation();
                    }
                }
                //validation: {
                //    validator: (val: string) => {
                //        if (!val) {
                //            return false;
                //        }
                //        let valSplit = val.trim().split(' ');
                //        return valSplit.length > 1;
                //    },
                //    message: "Please enter a first and last name.",
                //    onlyIf: () => {
                //        return this.EnableGuestValidation();
                //    }
                //}
            });
            // Subscribe to the GuestName observable so we can split it out into first and last name
            this.GuestName.subscribe((newValue) => {
                if (!this.GuestName() || this.GuestName().length < 1) {
                    return;
                }
                const nameSplit = this.GuestName().trim().split(' ');
                const namesLength = nameSplit.length;
                if (namesLength < 1) {
                    return;
                }
                const first = namesLength > 1 ?
                    nameSplit.map((val, index, array) => {
                        if (index <= namesLength - 2)
                            return val.trim().toTitleCase();
                    }).join(' ')
                    : nameSplit[0].length > 0
                        ? nameSplit[0].trim().toTitleCase()
                        : "";
                const last = namesLength > 1 ? nameSplit[namesLength - 1].trim().toTitleCase() : "";
                this.FirstName(first.trim());
                this.LastName(last.trim());
            });
            ////////////////////////////
            // General Purpose functions
            ///////////////////////////
            this.formatPhone = (data, event) => {
                const val = $(event.currentTarget).val();
                if (!val || event.keyCode == 8) {
                    return;
                }
                const formattedPhone = iLSHelpers.formatPhone(val, { allowExtensions: false, includeParenthesis: true, allowInternational: false });
                $(event.currentTarget).val(formattedPhone);
                this.Phone(formattedPhone);
            };
            this.formatGuestName = (data, event) => {
                const val = $(event.currentTarget).val();
                if (!val || event.keyCode == 8) {
                    return;
                }
                const formattedName = val.toTitleCase();
                $(event.currentTarget).val(formattedName);
                this.GuestName(formattedName);
            };
            this.toJsObject = () => {
                var self = this;
                const copy = {
                    FirstName: self.FirstName(),
                    LastName: self.LastName(),
                    Phone: self.Phone(),
                    Email: self.Email(),
                    RenterCommentsAndQuestions: self.RenterCommentsAndQuestions(),
                    MoveInDate: self.MoveInDate(),
                    RequireEmailOrPhone: self.RequireEmailOrPhone()
                };
                return copy;
            };
        }
    }
    ils.GuestCardInfo = GuestCardInfo;
    class Roommate {
        constructor(item) {
            if (!item) {
                item = {};
            }
            this.RoommateLocalId = ko.observable(typeof (item.RoommateLocalId) == "undefined" || item.RoommateLocalId == null || parseInt(item.RoommateLocalId.toString()) === NaN ? Helpers.getRandomInt() : item.RoommateLocalId);
            this.RoommateOrder = ko.observable(typeof (item.RoommateOrder) == "undefined" || item.RoommateOrder == null || parseInt(item.RoommateOrder.toString()) === NaN ? 0 : item.RoommateOrder);
            this.GuestInfo = !item.GuestInfo ? new GuestCardInfo() : item.GuestInfo;
            this.RoommateTitle = ko.computed(() => {
                return `Roommate ${this.RoommateOrder()}`;
            });
        }
        CloseRoommate() {
            if (!ils.viewModel || !ils.viewModel.ProspectForm.RemoveRoommate) {
                return;
            }
            ils.viewModel.ProspectForm.RemoveRoommate(this.RoommateLocalId());
        }
        ;
    }
    ils.Roommate = Roommate;
})(ils || (ils = {}));

var ils;
(function (ils) {
    class PageTiming {
        constructor(itemName) {
            this.name = itemName;
            this.timeDuration = 0;
            this.startTime = null;
            this.endTime = null;
            this.startTracking = () => {
                this.startTime = new Date();
            };
            this.stopTracking = () => {
                this.endTime = new Date();
                var timeSpent = this.startTime == null || typeof (this.startTime) == 'undefined' ? 0 : this.endTime - this.startTime;
                var hourInMillis = 1000 * 60 * 60;
                if (timeSpent > 0 && timeSpent < hourInMillis)
                    this.timeDuration += timeSpent;
                this.startTime = null;
                this.endTime = null;
            };
            this.isCurrentlyTracking = () => {
                return this.startTime != null && this.endTime == null;
            };
        }
    }
    ils.PageTiming = PageTiming;
})(ils || (ils = {}));

var ils;
(function (ils) {
    function loadApartmentMapScripts(callback) {
        if (ils.googleDynamicMapsIsLoading) {
            return;
        }
        ils.googleDynamicMapsIsLoading = true;
        let googleMapsScript = document.createElement('script');
        let infoBoxScript = document.createElement('script');
        googleMapsScript.setAttribute("src", `https://maps.googleapis.com/maps/api/js?key=${ils.googleMapsKey}&libraries=geometry`);
        infoBoxScript.setAttribute("src", "/tft-js/fallback/infobox.js");
        googleMapsScript.onload = () => {
            document.body.appendChild(infoBoxScript);
            ils.mapCenter = new google.maps.LatLng(ils.googleMapsLat, ils.googleMapsLong);
            ils.googleMapsApiLoaded = true;
        };
        infoBoxScript.onload = () => {
            if (callback) {
                callback();
            }
            ils.googleDynamicMapsIsLoading = false;
            ils.googleDynamicMapsLoaded = true;
            ils.infoBoxLoaded = true;
        };
        // It's possible that we have already loaded the google maps api. If so we skip loading it here and just load the info-box script
        if (!ils.googleMapsApiLoaded) {
            document.body.appendChild(googleMapsScript);
        }
        else if (!ils.infoBoxLoaded) {
            document.body.appendChild(infoBoxScript);
        }
    }
    ils.loadApartmentMapScripts = loadApartmentMapScripts;
    function loadApartmentStaticMapScripts(callback) {
        if (ils.googleMapsApiLoaded || ils.googleDynamicMapsIsLoading) {
            if (callback && !ils.googleDynamicMapsIsLoading) {
                callback();
            }
            return;
        }
        ils.googleDynamicMapsIsLoading = true;
        let googleMapsScript = document.createElement('script');
        googleMapsScript.setAttribute("src", `https://maps.googleapis.com/maps/api/js?key=${ils.googleMapsKey}&libraries=geometry`);
        googleMapsScript.onload = () => {
            ils.mapCenter = new google.maps.LatLng(ils.googleMapsLat, ils.googleMapsLong);
            ils.googleMapsApiLoaded = true;
            if (callback) {
                callback();
            }
            ils.googleDynamicMapsIsLoading = false;
        };
        document.body.appendChild(googleMapsScript);
    }
    ils.loadApartmentStaticMapScripts = loadApartmentStaticMapScripts;
})(ils || (ils = {}));

var ils;
(function (ils) {
    var maps = ils.ApartmentMaps;
    ils.trackedAdViews = [];
    ils.trackedImpressions = [];
    ils.primaryGuest = ils.primaryGuest || {};
    ils.showRoommates = ils.showRoommates || false;
    ils.floorPlanLoaded = false;
    ils.activeTabHash = "";
    ils.isSiteLive = ils.isSiteLive || false;
    ils.hasRoommates = ils.hasRoommates || false;
    ils.sessionRoommates = !ils.sessionRoommates ? [] : ils.sessionRoommates;
    ils.communityUrl = globalThis.currentURL;
    var pageTimings = [];
    var currentTiming;
    var isAutoScrolling = false;
    var allFloorPlansLoaded = false;
    var readMoreClicked = false;
    var shoppingDiningIsLoaded = false;
    var windowInactiveTime;
    var originalMoveInDate = null;
    // KO Validation setup
    const koValidationSettings = {
        insertMessages: true,
        messageTemplate: "customErrorTemplate",
        errorElementClass: 'error',
        errorsAsTitle: true,
        parseInputAttributes: false,
        messagesOnModified: false,
        decorateElementOnModified: true,
        decorateInputElement: true
    };
    ko.validation.init(koValidationSettings);
    let parsedRoommates = [];
    if (ils.sessionRoommates.length > 0) {
        ils.sessionRoommates.forEach((val, idx, roommates) => {
            if (!val) {
                return;
            }
            let roommate = new ils.Roommate({
                GuestInfo: new ils.GuestCardInfo({
                    Email: val.Email,
                    Phone: val.Phone,
                    FirstName: val.FirstName,
                    LastName: val.LastName,
                    RequireEmailOrPhone: false
                }),
                RoommateOrder: idx + 1
            });
            parsedRoommates.push(roommate);
        });
        ils.hasRoommates = true;
    }
    ils.viewModel = {
        FloorPlans: ko.observableArray([]),
        BedroomMin: ko.observable(window["bedroomMin"]),
        BedroomMax: ko.observable(window["bedroomMax"]),
        PriceMin: ko.observable(window["priceMin"]),
        PriceMax: ko.observable(window["priceMax"]),
        ProspectForm: new ils.ProspectFormData({ PrimaryGuest: new ils.GuestCardInfo(ils.primaryGuest), CommunityName: ils.communityTitle, ShowRoommatesOption: ils.showRoommates, HasRoommates: ils.hasRoommates && ils.showRoommates, Roommates: parsedRoommates }),
        SubmittedContactTypes: ko.observableArray([]),
        HoursOpen: ko.observableArray([]),
        GetInfoButtonsVisible: ko.observable(false),
        IsApplyNowVisible: ko.observable(ils.isApplyNowVisible),
        ApplyNowUrl: ko.observable(ils.applyNowUrl),
        contactMenuHtml: ko.observable(`<span class="ilsicon ilsicon-mail"></span>&nbsp;Email`),
        getMoreInfoHtml: ko.observable(`<span class="ilsicon ilsicon-ask-bubbles"></span>&nbsp;Get More Information`),
        NeighborhoodMapContents: ko.observable(''),
        DirectionsMapContents: ko.observable(''),
        ActiveTabText: ko.observable(null),
        ReadyToSubmit: ko.observable(false),
        DateOfVisit: ko.observable(null),
        ClickedFeaturedCallToAction: ko.observable(null),
        PreferredMoveInTypes: ko.observableArray([]),
        PreferredMoveIn: ko.observable(null),
        MoveInDate: ko.observable(null)
    };
    ils.viewModel.ContactTitle = ko.computed(function () {
        return ils.viewModel.ProspectForm.ContactTypeID() == 1
            ? ils.askQuestionText
            : ils.viewModel.ProspectForm.ContactTypeID() == 2
                ? "Schedule a Tour"
                : ils.viewModel.ProspectForm.ContactTypeID() == 5
                    ? "Apply Online"
                    : "Check Availability";
    });
    ils.viewModel.FloorPlanPrices = ko.computed(function () {
        var tmpPrices = [];
        for (var i = 0; i < ils.viewModel.FloorPlans().length; i++) {
            if (ils.viewModel.FloorPlans()[i].Price > 0)
                tmpPrices.push(ils.viewModel.FloorPlans()[i].Price);
        }
        if (tmpPrices.length === 0) {
            return [100, 2000];
        }
        tmpPrices = tmpPrices.sort(function (a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        });
        var prices = [tmpPrices[0], tmpPrices[tmpPrices.length - 1]];
        prices[0] = Math.floor(prices[0] / 50) * 50;
        prices[1] = Math.ceil(prices[1] / 50) * 50;
        return prices;
    });
    ils.viewModel.FloorPlanBedrooms = ko.computed(function () {
        var bedrooms = [];
        for (var i = 0; i < ils.viewModel.FloorPlans().length; i++) {
            bedrooms.push(ils.viewModel.FloorPlans()[i].NumberBedrooms);
        }
        if (bedrooms.length === 0) {
            return [0, 5];
        }
        return bedrooms.sort();
    });
    ils.viewModel.FiltersInUse = ko.computed(function () {
        return ils.viewModel.BedroomMin() != ils.viewModel.FloorPlanBedrooms()[0] || ils.viewModel.BedroomMax() != ils.viewModel.FloorPlanBedrooms()[ils.viewModel.FloorPlanBedrooms().length - 1] || ils.viewModel.PriceMin() != ils.viewModel.FloorPlanPrices()[0] || ils.viewModel.PriceMax() != ils.viewModel.FloorPlanPrices()[ils.viewModel.FloorPlanPrices().length - 1];
    });
    ils.viewModel.FilteredFloorPlans = ko.computed(function () {
        return ko.utils.arrayFilter(ils.viewModel.FloorPlans(), function (item) {
            return (
            // Check BedroomMin
            (ils.viewModel.BedroomMin() === null || ils.viewModel.BedroomMin() === undefined || item.NumberBedrooms >= ils.viewModel.BedroomMin()) &&
                // Check BedroomMax
                (ils.viewModel.BedroomMax() === null || ils.viewModel.BedroomMax() === undefined || item.NumberBedrooms <= ils.viewModel.BedroomMax()) &&
                // Check PriceMin
                (ils.viewModel.PriceMin() === null || ils.viewModel.PriceMin() === undefined || item.Price >= ils.viewModel.PriceMin() || item.Price == 0) &&
                // Check PriceMax
                (ils.viewModel.PriceMax() === null || ils.viewModel.PriceMax() === undefined || item.Price <= ils.viewModel.PriceMax()));
        });
    });
    ils.viewModel.ScheduleTour = function () {
        navigateToScheduleTour();
    };
    ils.viewModel.ApplyNow = function () {
        navigateToApplyNow();
    };
    ils.viewModel.checkAvailabilityClick = function () {
        navigateToCheckAvailability();
    };
    ils.viewModel.ReadyToSubmit.subscribe((newVal) => {
        // We ignore the "Apply Online" contact type here because we have to handle that in a separate method
        // in order to forward the user onto the online application link
        if (!newVal || ils.viewModel.ProspectForm.ContactTypeID() === 5) {
            return;
        }
        //$(".contact-submit").click();
        ils.viewModel.SubmitContactForm();
    });
    ils.viewModel.ProspectForm.StepManager.ActiveView.subscribe((newVal) => {
        if (!newVal || newVal !== ils.showcase.ViewType.Comments) {
            return;
        }
        if (ils.viewModel.PreferredMoveInTypes().length > 1) {
            return;
        }
        // Add logic to set the move-in date based on what is selected
        fetch("/api/showcase/get-move-in-types")
            .then(response => response.json())
            .then((data) => {
            data.MoveInTypes.forEach((item, index) => {
                ils.viewModel.PreferredMoveInTypes.push(item);
            });
            if (!ils.viewModel.ProspectForm.StepManager.ShowRoommates()) {
                const customDateOption = ils.viewModel.PreferredMoveInTypes().find((opt) => {
                    return opt.Name.startsWith('Custom');
                });
                if (!(!customDateOption))
                    ils.viewModel.PreferredMoveIn(customDateOption);
            }
        })
            .catch(error => {
            console.error(`An error occurred while getting the Preferred Move In Types: ${error}`);
            let customDate = new ils.PreferredMoveInType({ Name: 'Custom Date', Id: 4, Description: '' });
            ils.viewModel.PreferredMoveInTypes.push(customDate);
            ils.viewModel.PreferredMoveIn(customDate);
        });
    });
    ils.viewModel.PreferredMoveIn.subscribe((newVal) => {
        if (!ils.showRoommates) {
            return;
        }
        if (!originalMoveInDate) {
            originalMoveInDate = !(document.querySelector("#uxNewAvailabilityDate_uxDate").value)
                ? moment().add(1, 'M').format("MM/DD/YYYY")
                : document.querySelector("#uxNewAvailabilityDate_uxDate").value;
        }
        if (!newVal) {
            ils.viewModel.MoveInDate(null);
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = "";
            return;
        }
        if (!newVal || newVal.Name.startsWith('Custom')) {
            ils.viewModel.MoveInDate(moment(originalMoveInDate).format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
        const now = moment();
        const currentYear = now.year();
        const nextYear = now.year() + 1;
        if (newVal.Name.startsWith('Fall')) {
            let moveIn = moment();
            if (newVal.Id < 100) {
                moveIn = now.isAfter(moment(`${currentYear}-08-15`))
                    ? moment(`${nextYear}-08-15`)
                    : moment(`${currentYear}-08-15`);
            }
            else {
                moveIn = now.isAfter(moment(`${currentYear}-08-15`))
                    ? moment(`${nextYear + 1}-08-15`)
                    : moment(`${nextYear}-08-15`);
            }
            ils.viewModel.MoveInDate(moveIn.format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
        if (newVal.Name.startsWith("Spring")) {
            let moveIn = moment();
            if (newVal.Id < 100) {
                moveIn = moment(`${nextYear}-01-01`);
            }
            else {
                moveIn = moment(`${nextYear + 1}-01-01`);
            }
            ils.viewModel.MoveInDate(moveIn.format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
        if (newVal.Name.startsWith("Immediate")) {
            let moveIn = moment().add(1, 'w');
            ils.viewModel.MoveInDate(moveIn.format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
    });
    ils.viewModel.SubmitApplyNowForm = function () {
        var processTimeout = setTimeout(function () {
            ils.viewModel.ProspectForm.OnNext();
            const result = ils.viewModel.SubmitContactForm();
            clearTimeout(processTimeout);
        }, 500);
        return true;
    };
    ils.viewModel.SubmitContactForm = function () {
        const returnVal = ils.viewModel.ProspectForm.ContactTypeID() === 5 && !(!ils.viewModel.ApplyNowUrl()) && ils.viewModel.IsApplyNowVisible();
        if (ils.viewModel.ProspectForm.SubmitHasBeenClicked() || !ils.viewModel.ReadyToSubmit())
            return returnVal;
        ils.viewModel.ProspectForm.SubmitHasBeenClicked(true);
        var stickyHeight = ($(".header").outerHeight(true) * ($(".header").hasClass("affix") ? 1 : 2)) + $("#cdp-menu-collapse.in").height();
        if (ils.viewModel.ProspectForm.IsFormValid()) {
            const dateOfVisit = `${$("#uxNewDateOfVisit_uxDate").val()} ${$("#uxNewTimeOfVisit").val()}`;
            ils.viewModel.DateOfVisit(dateOfVisit.trim());
            // If the user selected to schedule a tour but did not enter in a date and time, then we don't want to submit a tour, just a check availability or email
            if (ils.viewModel.ProspectForm.ContactTypeID() == 2 && (ils.viewModel.DateOfVisit() === null || ils.viewModel.DateOfVisit().length < 2)) {
                if (ils.viewModel.ProspectForm.SelectedFloorPlans().length > 0) {
                    ils.viewModel.ProspectForm.ContactTypeID(3);
                }
                else {
                    ils.viewModel.ProspectForm.ContactTypeID(1);
                }
            }
            // Extract the data from the form
            const payloadData = {
                firstName: ils.viewModel.ProspectForm.PrimaryGuest.FirstName(),
                lastName: ils.viewModel.ProspectForm.PrimaryGuest.LastName(),
                emailAddress: ils.viewModel.ProspectForm.PrimaryGuest.Email(),
                phone: ils.viewModel.ProspectForm.PrimaryGuest.Phone(),
                moveInDate: $("#uxNewAvailabilityDate_uxDate").val(),
                preferredMoveIn: ils.viewModel.PreferredMoveIn(),
                comments: ils.viewModel.ProspectForm.StepManager.NeedRoommate()
                    ? `${ils.viewModel.ProspectForm.PrimaryGuest.RenterCommentsAndQuestions()} This renter has indicated they need roommate matching.`
                    : ils.viewModel.ProspectForm.PrimaryGuest.RenterCommentsAndQuestions(),
                showcaseItemID: ils.communityId,
                communityName: ils.communityName,
                contactTypeID: ils.viewModel.ProspectForm.ContactTypeID(),
                dateOfVisit: ils.viewModel.DateOfVisit(),
                floorPlanIDs: ils.viewModel.ProspectForm.SelectedFloorPlans(),
                hasRoommates: ils.viewModel.ProspectForm.StepManager.HasRoommates(),
                roommates: ils.viewModel.ProspectForm.StepManager.HasRoommates() ? ils.viewModel.ProspectForm.Roommates().map(r => r.GuestInfo.toJsObject()) : [],
                needsRoommate: ils.viewModel.ProspectForm.StepManager.NeedRoommate(),
                cdpSessionId: ils.cdpSessionId
            };
            var jsonData = JSON.stringify(payloadData);
            // extract the floor plan names so we can use them in statistics and analytics
            const selectedFloorPlanNames = ils.viewModel.ProspectForm.SelectedFloorPlans().map((floorPlanId) => {
                let floorPlan = ils.viewModel.FloorPlans().find(fpx => fpx.FloorPlanID === floorPlanId);
                return !floorPlan ? 'null' : floorPlan.Name;
            });
            // We have to use the "mvc-api" endpoint here (instead of Web API) because the code processing this POST relies on SessionState and
            // WebAPI does not have access to session state (easily).  *sigh*
            var contactUrl = `/mvc-api/showcase/submit-contact-form`;
            fetch(contactUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: jsonData
            })
                .then(response => response.json())
                .then(data => {
                submitContactFormResponse(payloadData, selectedFloorPlanNames);
            })
                .catch(error => {
                submitContactFormResponse(payloadData, selectedFloorPlanNames);
                console.error('SubmitContactForm failed', error);
            });
            ils.viewModel.ReadyToSubmit(false);
        }
        else {
            ils.viewModel.ProspectForm.SubmitHasBeenClicked(false);
            ils.viewModel.ReadyToSubmit(false);
        }
        function submitContactFormResponse(payloadData, selectedFloorPlanNames) {
            $('html, body').animate({
                scrollTop: $("#ask-question").offset().top - stickyHeight
            }, 100);
            ils.viewModel.SubmittedContactTypes.push(ils.viewModel.ProspectForm.ContactTypeID());
            const trackingData = {
                communityName: payloadData.communityName,
                communityId: payloadData.showcaseItemID,
                formType: ils.aptsforConstants.getContactFormTypeFromId(payloadData.contactTypeID),
                unitType: ils.showRoommates ? ils.aptsforConstants.unitTypes.Student : ils.aptsforConstants.unitTypes.Conventional,
                communityUrl: ils.communityUrl,
                numberOfRoommates: ils.showRoommates ? payloadData.roommates.length : 0,
                floorPlans: selectedFloorPlanNames ? selectedFloorPlanNames.join('; ').trim() : '',
                moveInDate: payloadData.moveInDate,
                needsRoommate: payloadData.needsRoommate,
                preferredMoveIn: payloadData.preferredMoveIn.Name,
                applyNowUrl: payloadData.contactTypeID === 5 ? ils.viewModel.ApplyNowUrl() : ''
            };
            TrackContactSubmit(trackingData);
            if (payloadData.contactTypeID === 5) {
                TrackShowcasePayPerClick(globalThis.ppcActionType.applyNowUrl, ils.communityId, ils.communityName, ils.communityUrl);
            }
            if (globalThis.abTestOverview != null)
                TrackABConversion(globalThis.abOverviewName, globalThis.abTestOverview ? "main" : "alternate", payloadData.communityName, payloadData.showcaseItemID);
            if (ils.viewModel.ProspectForm.ContactTypeID() == 2)
                TrackABView("ScheduleTourThanksView", globalThis.abTestVersion, ils.communityId, payloadData.communityName);
        }
        return returnVal;
    };
    function getHoursOpen(dateOfVisit) {
        fetch(`${globalThis.baseUrl}mvc-api/showcase/get-available-tour-start-times?showcaseItemID=${globalThis.showcaseItemID}&dateOfVisit=${dateOfVisit}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
            ils.viewModel.HoursOpen(data.d);
        })
            .catch(error => console.error(error));
    }
    function ToggleContactMenuABTest(testCase = "a") {
        if (testCase !== "a") {
            ils.viewModel.contactMenuHtml(`<span class="ilsicon ilsicon-ask-bubbles"></span>&nbsp;Next Steps`);
            ils.viewModel.getMoreInfoHtml(`<span class="ilsicon ilsicon-mail"></span>&nbsp;Get More Information`);
        }
        else {
            ils.viewModel.contactMenuHtml(`<span class="ilsicon ilsicon-mail"></span>&nbsp;Email`);
            ils.viewModel.getMoreInfoHtml(`<span class="ilsicon ilsicon-ask-bubbles"></span>&nbsp;Get More Information`);
        }
    }
    ils.ToggleContactMenuABTest = ToggleContactMenuABTest;
    function AddCommas(number) {
        let numberStr = number.toString();
        for (var i = 0; i < Math.floor((numberStr.length - (1 + i)) / 3); i++)
            numberStr = numberStr.substring(0, numberStr.length - (4 * i + 3)) + ',' + numberStr.substring(numberStr.length - (4 * i + 3));
        return numberStr;
    }
    ils.AddCommas = AddCommas;
    function ToggleSelectedFloorPlan(floorPlanID) {
        if ($.inArray(floorPlanID, ils.viewModel.ProspectForm.SelectedFloorPlans()) == -1)
            ils.viewModel.ProspectForm.SelectedFloorPlans.push(floorPlanID);
        else
            ils.viewModel.ProspectForm.SelectedFloorPlans(ko.utils.arrayFilter(ils.viewModel.ProspectForm.SelectedFloorPlans(), function (item) {
                return item != floorPlanID;
            }));
    }
    ils.ToggleSelectedFloorPlan = ToggleSelectedFloorPlan;
    function askQuestionMobile(contactTypeId, isFeaturedCallToAction = false) {
        if (!contactTypeId) {
            return;
        }
        ils.viewModel.ProspectForm.ContactTypeID(contactTypeId);
        switch (contactTypeId) {
            case 1:
                ils.viewModel.ActiveTabText("Get MoreInformation"); // We have no space between 'More' and 'Information' to keep it consistent with how we originally set it up and align with historical data on Google Analytics
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            case 2:
                ils.viewModel.ActiveTabText("Schedule a Tour");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            case 3:
                ils.viewModel.ActiveTabText("Check Availability");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            case 5:
                ils.viewModel.ActiveTabText("Apply Online");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            default:
                ils.viewModel.ActiveTabText("Get MoreInformation");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
        }
        var timeout = setTimeout(function () {
            $("#contact-menu").removeClass("in");
            $("#contact-menu").css("height", "20px");
            clearTimeout(timeout);
        }, 250);
    }
    ils.askQuestionMobile = askQuestionMobile;
    function checkAvailability(currentFloorPlan, e) {
        if (!currentFloorPlan) {
            return;
        }
        navigateToCheckAvailability();
        //$('.cdp-menu a[href="#ask-question"]').click();
        ToggleSelectedFloorPlan(currentFloorPlan.FloorPlanID);
    }
    ils.checkAvailability = checkAvailability;
    function BindPriceSlider() {
        var sliderElement = $("#uxPriceRangeSlider");
        var values = ils.viewModel.FloorPlanPrices();
        var value1 = globalThis.priceMin && globalThis.priceMin > values[0] ? globalThis.priceMin : values[0];
        var value2 = globalThis.priceMax && globalThis.priceMax < values[values.length - 1] ? globalThis.priceMax : values[values.length - 1];
        sliderElement.slider({
            range: true,
            step: 50,
            min: values[0],
            max: values[values.length - 1],
            values: [value1, value2],
            create: function (event, ui) {
                if (sliderElement.find(".handle-text").length == 0)
                    sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                UnstackSliderLabels(sliderElement.find(".ui-slider-handle:" + (value2 == values[0] ? "last" : "first")), value1, value2);
                priceSliderUpdateFilter(sliderElement);
            },
            slide: function (event, ui) {
                var handle = $(ui.handle);
                handle.find(".handle-text").html("$" + ui.value);
                UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
            },
            stop: function (event, ui) {
                priceSliderUpdateFilter(sliderElement);
            }
        });
        sliderElement.find(".handle-text:first").html("$" + value1);
        sliderElement.find(".handle-text:last").html("$" + value2);
    }
    ils.BindPriceSlider = BindPriceSlider;
    function FixHeightsAfterImagesLoaded(element) {
        $(element).imagesLoaded().always(function () {
            globalThis.SetDynamicElements($(element).parent());
        });
    }
    function TrackTimeForNewTab(tabName) {
        if (currentTiming)
            currentTiming.stopTracking();
        var previousTiming = ko.utils.arrayFirst(pageTimings, function (item) {
            return item.name == tabName;
        });
        if (previousTiming)
            currentTiming = previousTiming;
        else
            currentTiming = new ils.PageTiming(tabName);
        currentTiming.startTracking();
        if (!previousTiming)
            pageTimings.push(currentTiming);
    }
    function SendTimings() {
        if (globalThis.hasRoles || !ils.isSiteLive)
            return;
        currentTiming.stopTracking();
        for (var i = 0; i < pageTimings.length; i++) {
            if (pageTimings[i].timeDuration > 0) {
                ils.trackTimingEvent("CDP Tab", pageTimings[i].name, Math.min(pageTimings[i].timeDuration, 600000), ils.communityName, ils.communityId); //Don't allow for more than 10 minutes per tab (idle)
                if (globalThis.abTestOverview != null) {
                    ils.trackTimingEvent("ABCDP Tab" + (globalThis.abTestOverview ? "main" : "alternate"), pageTimings[i].name, Math.min(pageTimings[i].timeDuration, 600000), ils.communityName, ils.communityId); //Don't allow for more than 10 minutes per tab (idle)
                }
            }
        }
        for (let i = 0; i < ils.viewModel.ProspectForm.StepManager.ProgressSteps().length; i++) {
            let step = ils.viewModel.ProspectForm.StepManager.ProgressSteps()[i];
            step.StepTiming.stopTracking();
            if (!step || step.StepTiming.timeDuration <= 0) {
                continue;
            }
            let timeDuration = Math.min(step.StepTiming.timeDuration, 600000); // Max 10 minutes so we don't count idle time
            ils.trackTimingEvent("Form Step", step.StepTiming.name, timeDuration, ils.communityName, ils.communityId);
            //ga('send', 'timing', 'Form Step', step.StepTiming.name, timeDuration);
            if (!ils.isSiteLive) {
                console.log(`Total time sent to Google Analytics for ${step.StepName} is ${timeDuration.toString()}`);
            }
        }
    }
    function scrollToActiveTab(hrefHashId) {
        isAutoScrolling = true;
        $([document.documentElement, document.body]).animate({
            scrollTop: $(hrefHashId).offset().top - 100
        }, 0, function () {
            isAutoScrolling = false;
        });
    }
    ;
    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    }
    ;
    function setTabFromScrollPosition() {
        let targetHref = ils.activeTabHash;
        // This iterates through each tab section (the viewable area of the tab) and sets the tab to active or inactive. The last one we process here
        // is the one that will be the active tab
        $('.cdp-section').each(function () {
            if ($(window).scrollTop() >= ($(this).offset().top - 300)) {
                var id = $(this).attr('id');
                targetHref = $(".nav li.cdp-tab a[href='#" + id + "']").attr("href");
                $(".nav li.cdp-tab").toggleClass("active", false);
                $(".nav li.cdp-tab a[href='#" + id + "']").parent("li").toggleClass("active", true);
            }
        });
        // Take action on the tab we ended up on
        if (targetHref !== ils.activeTabHash) {
            takeActionOnTab(targetHref);
            ils.activeTabHash = targetHref;
        }
    }
    ;
    function navigateToCheckAvailability() {
        ils.viewModel.ActiveTabText("Check Availability");
        ils.viewModel.ProspectForm.ContactTypeID(3);
        switchTabs(null, "#ask-question");
    }
    function navigateToScheduleTour() {
        ils.viewModel.ActiveTabText("Schedule a Tour");
        ils.viewModel.ProspectForm.ContactTypeID(2);
        switchTabs(null, "#ask-question");
        // Make a call to the API to sync latest tour times
        fetch(`${globalThis.baseUrl}mvc-api/showcase/sync-available-tour-time-slots?showcaseItemID=${globalThis.showcaseItemID}`, {
            method: 'GET'
        })
            .then(response => response.text())
            .then(content => {
            console.log(content);
        })
            .catch(error => console.warn(error));
    }
    function navigateToApplyNow() {
        ils.viewModel.ActiveTabText("Apply Now");
        ils.viewModel.ProspectForm.ContactTypeID(5);
        switchTabs(null, "#ask-question");
    }
    function takeActionOnTab(targetHref) {
        if (!targetHref) {
            return;
        }
        const text = !ils.viewModel.ActiveTabText() ? $(`.cdp-menu a[href='${targetHref}']`).text().trim() : ils.viewModel.ActiveTabText();
        const tabClickData = {
            communityId: ils.communityId,
            communityName: ils.communityName,
            tabName: text,
            communityUrl: ils.communityUrl
        };
        ils.trackCDPTabClickEvent(tabClickData);
        TrackTimeForNewTab(text);
        ils.viewModel.ProspectForm.StepManager.TurnOnStepTimeTracking(targetHref === "#ask-question");
        // We're resetting this to an null because this only gets set when the text does not match the tab (i.e. Get More Information vs Schedule a Tour)
        ils.viewModel.ActiveTabText(null);
        // Take action based on the tab we're on
        if (targetHref == "#floorplans") {
            if (!ils.floorPlanLoaded) {
                BindPriceSlider();
                BindBedroomSlider();
                ils.floorPlanLoaded = true;
            }
        }
        else if (targetHref == "#neighborhood") {
            if (!ils.googleStaticNeighborhoodMapLoaded) {
                maps.initializeStaticNeighborhoodMap();
                if ($.inArray(globalThis.neighborhoodAdTypeID, ils.trackedAdViews) == -1) {
                    TrackAdView(globalThis.neighborhoodAdTypeID);
                    ils.trackedAdViews.push(globalThis.neighborhoodAdTypeID);
                }
            }
            else {
                if ($.inArray(globalThis.neighborhoodAdTypeID, ils.trackedAdViews) == -1) {
                    TrackAdView(globalThis.neighborhoodAdTypeID);
                    ils.trackedAdViews.push(globalThis.neighborhoodAdTypeID);
                }
            }
        }
        else if (targetHref == "#amenities" && !hasRoles) {
            if (ils.trackedImpressions.length == 0) {
                $(".attribute-list [data-impression]").each(function () {
                    var impressionID = $(this).data("impression");
                    ils.trackedImpressions.push(impressionID);
                });
                if (ils.trackedImpressions.length > 0)
                    $.ajax({
                        type: 'POST',
                        url: globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/TrackAttributeListingImpression",
                        data: '{ showcaseAttributeValueID: ' + JSON.stringify(ils.trackedImpressions) + '}',
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json'
                    });
            }
            if ($.inArray(globalThis.amenityAdTypeID, ils.trackedAdViews) == -1) {
                TrackAdView(globalThis.amenityAdTypeID);
                ils.trackedAdViews.push(globalThis.amenityAdTypeID);
            }
        }
        else if (targetHref == "#hours-directions") {
            if (!ils.googleStaticCommunityMapLoaded) {
                maps.initializeStaticMap();
            }
        }
        else if (targetHref == "#facebook-feed") {
            const clickData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                clickTypeId: ClickType.FacebookFeed
            };
            TrackClickData(clickData);
        }
        else if (targetHref == "#news") {
            const clickData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                clickTypeId: ClickType.LocalNews
            };
            TrackClickData(clickData);
        }
    }
    function switchTabs(e, target) {
        var _a;
        let targetHref = target !== null && target !== void 0 ? target : (_a = e.target) === null || _a === void 0 ? void 0 : _a.href;
        if (!targetHref) {
            let element = e.target;
            while (element && !element.hasAttribute('href') && !element.tagName.match(/body/i)) {
                element = element.parentElement;
            }
            const parentHref = element === null || element === void 0 ? void 0 : element.getAttribute('href');
            targetHref = parentHref !== null && parentHref !== void 0 ? parentHref : '#overview';
        }
        scrollToActiveTab(targetHref);
        if (globalThis.breakpoint() == "mobile")
            document.querySelectorAll('.cdp').forEach((el) => el.classList.remove('side-nav-open'));
    }
    function PhotoIframeClick(e) {
        const targetElem = $(e.target);
        let listElem = targetElem.closest('li');
        const isFloorPlan = listElem && listElem.hasClass("floorplan");
        let element = targetElem;
        if (!targetElem.is('[href]'))
            element = targetElem.closest('[href]'); //catch bubbles
        const photoModal = $("#photo-modal");
        const modalExtra = photoModal.find('.modal-extra');
        const modalNav = modalExtra.find('.modal-navigation');
        const galleryInfo = modalExtra.find(".gallery-info");
        const gallery = element.prop("rel") != '';
        const hasVirtualTour = element.data('tour');
        if (isFloorPlan) {
        }
        SetModalBodyContent(element);
        modalNav.toggle(gallery);
        galleryInfo.toggle(gallery);
        if (gallery) {
            if (element.hasClass("clone"))
                element = $(`[rel='${element.prop("rel")}'][href='${element.attr("href")}']:not(.clone)`);
            var galleryIndex = element.data("id");
            var totalInGallery = $(`[rel='${element.prop("rel")}']:not(.clone)`).length;
            if (element.prop("rel").indexOf("floorplan") == 0) {
                galleryIndex = 1;
                totalInGallery = $(".media-items [data-additional-galleries*=" + element.prop("rel").replace("floorplan-", "") + "]").length + 1;
            }
            photoModal.data("gallery-number", galleryIndex);
            photoModal.data("gallery-name", element.prop("rel"));
            galleryInfo.find(".current").html(galleryIndex);
            galleryInfo.find(".total").html(totalInGallery.toString());
            if (hasVirtualTour) {
                navigatePhotoModal(e, true);
            }
        }
        parent.$("#iframe-modal > .modal-dialog > .modal-content > .modal-header > .close").hide();
        photoModal.modal();
        photoModal.on('hide.bs.modal', function (e) {
            parent.$("#iframe-modal > .modal-dialog > .modal-content > .modal-header > .close").show();
        });
        return false;
    }
    function navigatePhotoModal(e, goToVirtualTour = false) {
        var photoModal = $("#photo-modal");
        var galleryInfo = photoModal.find(".modal-extra .gallery-info");
        var galleryName = photoModal.data("gallery-name");
        var nextIndex = photoModal.data("gallery-number");
        if ($(this).hasClass('prev'))
            nextIndex--;
        else
            nextIndex++;
        var totalItems = parseInt(galleryInfo.find(".total").text());
        if (nextIndex > totalItems)
            nextIndex = 1;
        else if (nextIndex <= 0)
            nextIndex = totalItems;
        galleryInfo.find(".current").html(nextIndex);
        photoModal.data("gallery-number", nextIndex);
        var element = galleryName.indexOf("floorplan") == -1
            ? $("a[rel='" + galleryName + "'][data-id='" + nextIndex + "']") : nextIndex == 1 ? $("a[rel=" + galleryName + "]")
            : goToVirtualTour
                ? $(`.media-items [data-floorplan-virtual-tour*=${galleryName.replace("floorplan-", "")}]:eq(${nextIndex - 2})`)
                : $(`.media-items [data-additional-galleries*=${galleryName.replace("floorplan-", "")}]:eq(${nextIndex - 2})`);
        SetModalBodyContent(element);
    }
    function SetModalBodyContent(element) {
        var photoModal = $("#photo-modal");
        var modalBody = photoModal.find('.modal-body');
        var modalExtra = photoModal.find('.modal-extra');
        if (element.attr("href") && element.attr("href").indexOf('#') == 0) {
            modalBody.html($(element.attr("href")).html());
            // This is how we track impressions on a 3Dx Virtual Tour. We can't track a click event on an iframe, so 
            // this is the next best thing.
            const displayElement = $($(element.attr("href")).html());
            if (displayElement.hasClass('virtual-tour-iframe')) {
                const vtUrl = displayElement.attr('src');
                Track3DxVirtualTourViewedEvent(vtUrl, ils.communityId, ils.communityName);
            }
        }
        else
            modalBody.html('<img alt="' + element.prop("title") + '" class="img-responsive" src="' + element.prop("href") + '" />');
        modalExtra.find(".title > span").html(element.prop("title"));
    }
    function BindBedroomSlider() {
        var sliderElement = $("#uxBedroomRangeSlider");
        var values = ils.viewModel.FloorPlanBedrooms();
        var value1 = globalThis.bedroomMin && globalThis.bedroomMin > values[0] ? globalThis.bedroomMin : values[0];
        var value2 = globalThis.bedroomMax && globalThis.bedroomMax < values[values.length - 1] ? globalThis.bedroomMax : values[values.length - 1];
        sliderElement.slider({
            range: true,
            min: values[0],
            max: values[values.length - 1],
            values: [value1, value2],
            create: function (event, ui) {
                if (sliderElement.find(".handle-text").length == 0)
                    sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                sliderElement.find(".handle-text:first").html(FormatBedroomText(value1));
                sliderElement.find(".handle-text:last").html(FormatBedroomText(value2));
                sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                UnstackSliderLabels(sliderElement.find(".ui-slider-handle:" + (value2 == values[0] ? "last" : "first")), value1, value2);
                bedroomSliderUpdateFilter(sliderElement);
            },
            slide: function (event, ui) {
                var handle = $(ui.handle);
                handle.find(".handle-text").html(FormatBedroomText(ui.value));
                UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
            },
            stop: function (event, ui) {
                bedroomSliderUpdateFilter(sliderElement);
            }
        });
    }
    function priceSliderUpdateFilter(sliderElement) {
        var minValue = sliderElement.slider("values", 0);
        var maxValue = sliderElement.slider("values", 1);
        ils.viewModel.PriceMin(minValue);
        ils.viewModel.PriceMax(maxValue);
    }
    function bedroomSliderUpdateFilter(sliderElement) {
        var minValue = sliderElement.slider("values", 0);
        var maxValue = sliderElement.slider("values", 1);
        if (minValue == "Studio")
            minValue = 0;
        if (maxValue == "Studio")
            maxValue = 0;
        ils.viewModel.BedroomMin(minValue);
        ils.viewModel.BedroomMax(maxValue);
    }
    function UnstackSliderLabels(handle, value1, value2) {
        var unstackTimeout = setTimeout(function () {
            var handleText = handle.find(".handle-text");
            var rightHandleLabel = handle.parent().find(".ui-slider-handle:last .handle-text");
            if (value1 == value2) {
                handle.addClass("on-top");
                handleText.html("Only");
            }
            else {
                handle.removeClass("on-top");
            }
            var leftHandleLabel = handle.parent().find(".ui-slider-handle:first .handle-text");
            leftHandleLabel.css("margin-left", "0px");
            rightHandleLabel.css("margin-left", "0px");
            var leftHandleEnd = leftHandleLabel.offset().left + leftHandleLabel.outerWidth(true);
            var rightHandleStart = rightHandleLabel.offset().left;
            var offset = rightHandleStart - leftHandleEnd;
            if (offset < 0) {
                if (handle.hasClass("reverse"))
                    rightHandleLabel.css("margin-left", offset + "px");
                else
                    leftHandleLabel.css("margin-left", offset + "px");
            }
            clearTimeout(unstackTimeout);
        }, 5);
    }
    function FormatBedroomText(numBeds) {
        return numBeds == 0 ? "Studio" : numBeds + "BR";
    }
    document.addEventListener("DOMContentLoaded", function () {
        ////////////////////////////
        // Setup analytics tracking for 3Dx Virtual Tours 
        ////////////////////////////
        const virtualTourFrames = document.getElementsByClassName("virtual-tour-iframe");
        if (virtualTourFrames.length > 0) {
            window.addEventListener('blur', () => {
                var isVirtualTour = document.activeElement.classList.contains('virtual-tour-iframe');
                if (isVirtualTour) {
                    try {
                        const activatedVirtualTour = document.activeElement;
                        const src = activatedVirtualTour.src;
                        console.log("Sending 'Explored' event for 3Dx Virtual Tours");
                        Track3DxVirtualTourViewedEvent(src, ils.communityId, ils.communityName);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            });
        }
        // Time tracking for tabs
        TrackTimeForNewTab($(".cdp-menu .active a").text());
        ko.applyBindings(ils.viewModel);
        if ($("#floorplans").length > 0)
            $.ajax({
                type: 'POST',
                url: globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/LoadFloorPlans",
                data: `{ showcaseItemID: "${globalThis.showcaseItemID}"}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (data) {
                    var tempFloorPlans = [];
                    for (let i = 0; i < data.d.length; i++) {
                        let sourcePlan = {};
                        Object.assign(sourcePlan, data.d[i]);
                        sourcePlan.VirtualTourUrl = data.d[i].VirtualTourMedia ? data.d[i].VirtualTourMedia.URL : null;
                        let tempPlan = new ils.FloorPlanInfo(sourcePlan);
                        tempFloorPlans.push(tempPlan);
                    }
                    ils.viewModel.FloorPlans(tempFloorPlans);
                    $(".floorplan .add-tooltip").tooltip();
                    $(".add-tooltip-with-info").each(function () {
                        $(this).tooltip({ html: true, title: $(this).html() });
                        $(this).html('&nbsp;<i class="fa fa fa-info-circle"></i>');
                        $(this).removeClass("add-tooltip").addClass("tooltip-added");
                    });
                    //$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                    //    switchTabs(e);
                    //});
                    $('[data-contact="check-availability"]').on("click", function (e) {
                        $(e.target).attr("href", "#ask-question");
                        ils.viewModel.ActiveTabText("Check Availability");
                        ils.viewModel.ProspectForm.ContactTypeID(3);
                    });
                    allFloorPlansLoaded = true;
                    FixHeightsAfterImagesLoaded($("#floorplans"));
                    BindPriceSlider();
                    BindBedroomSlider();
                    // This shows/hides elements that are being used for A/B tests on Google Optimize. The `.g-ab-test` is a custom class for targeting elements
                    var timeout = setTimeout(function () {
                        $('.g-ab-test').toggleClass("hide", !globalThis.googleOptimizeIsLoaded);
                        clearTimeout(timeout);
                    }, 2000);
                }
            });
        window.addEventListener('focus', function () {
            var _a;
            if (!windowInactiveTime)
                return;
            try {
                const timeInactive = Math.abs((new Date() - windowInactiveTime));
                (_a = currentTiming.startTime) === null || _a === void 0 ? void 0 : _a.setMilliseconds(currentTiming.startTime.getMilliseconds() + timeInactive);
            }
            catch (error) {
                console.error(error);
            }
        });
        window.addEventListener('blur', function () {
            windowInactiveTime = new Date();
        });
        if (parent.$("#iframe-modal").length > 0) {
            $("body").addClass("in-modal");
            parent.$("#iframe-modal").off('hide.bs.modal').off('hidden.bs.modal').on('hide.bs.modal', function (e) {
                SendTimings();
                ils.viewModel.ProspectForm.StepManager.SendFormCompletionMetrics(ils.viewModel.ProspectForm.SubmitHasBeenClicked());
            }).on('hidden.bs.modal', function (e) {
                $(e.target).find(".modal-body").html("");
            });
            parent.$(window).blur(function () {
                windowInactiveTime = new Date();
            });
        }
        else {
            window.addEventListener('beforeunload', function (event) {
                SendTimings();
                ils.viewModel.ProspectForm.StepManager.SendFormCompletionMetrics(ils.viewModel.ProspectForm.SubmitHasBeenClicked());
            });
        }
        if (!globalThis.hasRoles) {
            ils.trackCommunityViewEvent({ communityId: ils.communityId, communityName: ils.communityName, communityUrl: ils.communityUrl });
        }
        if (globalThis.abTestOverview != null) {
            TrackABView(`${globalThis.abOverviewName}View`, globalThis.abTestOverview ? "main" : "alternate", ils.communityId, ils.communityName);
        }
        $(".header-action a.href-action").on('click', function () {
            const text = $(this).text();
            // If they click the phone number in the upper right of the CDP
            if (text && text.startsWith('(')) {
                TrackClickData({ clickTypeId: 9, communityId: ils.communityId, communityName: ils.communityName, communityUrl: ils.communityUrl });
            }
        });
        function OnResize() {
            document.querySelector(".header").style.width = `${document.querySelector(".body-content").offsetWidth}px`;
        }
        window.addEventListener('resize', function () {
            OnResize();
        });
        OnResize();
        if ($(".navigation .navbar").length > 0) {
            $(".header").affix({
                offset: { top: Math.max($(".navigation").outerHeight(true), 1) }
            });
            $($(window).width() < 985 ? "#cdp-menu-collapse" : ".cdp-menu").affix({
                offset: {
                    top: Math.max($(".navigation").outerHeight(true), 1),
                    bottom: function () {
                        if ($("footer").length > 0)
                            return (this.bottom = $("footer").outerHeight(true) + parseInt($(".cdp").css("padding-bottom")));
                    }
                }
            }).on("affix.bs.affix", function () {
                if ($(window).scrollTop() == 0)
                    return false;
            });
        }
        else {
            $(".header," + ($(window).width() < 985 ? "#cdp-menu-collapse" : ".cdp-menu")).addClass("affix");
            $(".body-content .tab-content").css("padding-top", $(".header").outerHeight() + 10);
        }
        if (globalThis.breakpoint() == "mobile") {
            $(".header .navbar-toggle").on('click', function () {
                $(".cdp").toggleClass("side-nav-open");
                return false;
            });
        }
        const tabLinks = document.querySelectorAll('a[data-toggle="tab"]');
        tabLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                const targetElem = e.target;
                const target = targetElem.getAttribute("href");
                switchTabs(e, target);
            });
        });
        const tabClickLinks = document.querySelectorAll('a[data-toggle="tab-click"]');
        tabClickLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                const targetElem = e.target;
                const target = targetElem.getAttribute("href");
                switchTabs(e, target);
                ils.viewModel.ProspectForm.ContactTypeID(1);
            });
        });
        const contactMenu = document.querySelector("#contact-menu a");
        if (contactMenu) {
            contactMenu.addEventListener('click', function () {
                const contactOptions = document.querySelectorAll(".contact-options a");
                if (contactOptions.length > 0) {
                    contactOptions[0].click();
                }
            });
        }
        if (globalThis.breakpoint() == "mobile") {
            const cdpMenuLinks = document.querySelectorAll(".header .cdp-menu a");
            cdpMenuLinks.forEach(link => {
                link.addEventListener('click', () => {
                    document.querySelector(".navbar-toggle").click();
                });
            });
        }
        $(".media-items a[rel], .media-item").on('click', PhotoIframeClick);
        $(document).on('click', '.floorplan .photo', PhotoIframeClick);
        $("#photo-modal .modal-navigation a").on("click", navigatePhotoModal);
        if ($(".media-items ul li").length <= 5 && globalThis.breakpoint() != "mobile") {
            $(".media-items ul").css({ margin: "0 auto", width: $(".media-items ul li").outerWidth(true) * $(".media-items ul li").length });
        }
        if (globalThis.breakpoint() == "mobile") {
            $(".map-address").each(function () {
                var mapLink = '<a target="_blank" href="http://maps.google.com/?q=' + $(this).text().replace("<br>", " ") + '">' + $(this).html() + '</a>';
                $(this).html(mapLink);
            });
        }
        $(".resend").on('click', function () {
            $(".send-container").show();
            $(".send-complete").hide();
        });
        $("#uxSwitchDirection").on('click', function () {
            var directionAValue = $("#uxDirectionsAptAddress").val();
            var directionAPlaceHolder = $("#uxDirectionsAptAddress").attr("placeholder");
            var directionBValue = $("#uxDirectionsBAddress").val();
            var directionBPlaceHolder = $("#uxDirectionsBAddress").attr("placeholder");
            $("#uxDirectionsAptAddress").val(directionBValue).attr("placeholder", directionBPlaceHolder);
            $("#uxDirectionsBAddress").val(directionAValue).attr("placeholder", directionAPlaceHolder);
            return false;
        });
        $("#uxGetDirections").on('click', function () {
            var directionAValue = $("#uxDirectionsAptAddress").val();
            var directionBValue = $("#uxDirectionsBAddress").val();
            if (directionAValue == globalThis.communityName) {
                directionAValue = globalThis.residenceAddress;
            }
            if (directionBValue == globalThis.communityName) {
                directionBValue = globalThis.residenceAddress;
            }
            GetDirections(directionAValue, directionBValue);
            return false;
        });
        function GetDirections(sAddr, dAddr) {
            sAddr = sAddr.replace(/ /g, "+");
            dAddr = dAddr.replace(/ /g, "+");
            if (sAddr == '' || dAddr == '') {
                alert('You must fill in your address to get directions.');
                return;
            }
            const clickData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                clickTypeId: ClickType.Directions
            };
            TrackClickData(clickData);
            var directionsUrl = `http://maps.google.com/maps?f=d&source=s_d&saddr=${sAddr}&daddr=${dAddr}&hl=en`;
            const keyLeadData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                keyLeadType: ils.aptsforConstants.keyLeadTypes.directionsRequested,
                additionalData: {
                    directionsUrl: directionsUrl
                }
            };
            ils.trackKeyLead(keyLeadData);
            window.open(directionsUrl);
        }
        $(".add-tooltip").tooltip();
        if ($(".contact-form ul.floorplans li").length == 5 && globalThis.breakpoint() != "mobile") {
            $(".contact-form ul.floorplans").css({ margin: "0 auto", width: $(".contact-form ul.floorplans li").css("min-width") });
        }
        $("#selectAllFloorplans,#newSelectAllFloorPlans").on('click', function () {
            for (var i = 0; i < ils.viewModel.FloorPlans().length; i++) {
                if ($.inArray(ils.viewModel.FloorPlans()[i].FloorPlanID, ils.viewModel.ProspectForm.SelectedFloorPlans()) == -1)
                    ils.viewModel.ProspectForm.SelectedFloorPlans.push(ils.viewModel.FloorPlans()[i].FloorPlanID);
            }
        });
        $("#uxNewDateOfVisit_datetimepicker").on("dp.change", function (e) {
            ils.viewModel.ProspectForm.DateOfVisit(e.date);
            let dateValue = `${$("#uxNewDateOfVisit_uxDate").val()}`;
            if (!dateValue || dateValue === "undefined") {
                dateValue = "";
            }
            getHoursOpen(dateValue);
        });
        const shareLinks = document.querySelectorAll(".share-links a[target='_blank']");
        shareLinks.forEach(link => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                window.open(link.getAttribute("href"), link.getAttribute("title"), 'width=640,height=300');
            });
        });
        const photoModal = document.querySelector("#photo-modal");
        if (photoModal) {
            photoModal.addEventListener("keydown", (e) => {
                var _a, _b;
                switch (e.key) {
                    case "ArrowLeft":
                        (_a = document.querySelector(".modal-navigation .prev")) === null || _a === void 0 ? void 0 : _a.click();
                        break;
                    case "ArrowRight":
                        (_b = document.querySelector(".modal-navigation .next")) === null || _b === void 0 ? void 0 : _b.click();
                        break;
                    default:
                        return;
                }
                e.preventDefault();
            });
        }
        if (!$("#neighborhood").hasClass("all-blocks")) {
            $("#neighborhood .on-the-left").append($("#neighborhood .summary"));
        }
        // Write a vanilla JS query for all elements containing the class 'other-communities' and loop through them to add the click event
        const otherCommunities = document.querySelectorAll(".other-communities .community");
        otherCommunities.forEach(community => {
            community.addEventListener("click", (e) => {
                var _a;
                let element = e.target;
                while (element && !element.getAttribute('href')) {
                    element = element.parentNode;
                }
                if (element && !hasRoles) {
                    ils.trackCDPClickEvent({
                        communityId: ils.communityId,
                        communityName: ils.communityName,
                        communityUrl: ils.communityUrl,
                        clickTypeId: ClickType.ScheduleTourNearbyCommunities,
                        clickType: getClickTypeNameFromId(ClickType.ScheduleTourNearbyCommunities),
                        relatedData: (_a = element.querySelector(".name")) === null || _a === void 0 ? void 0 : _a.textContent
                    });
                }
                const iframeModal = parent.document.querySelector("#iframe-modal");
                if (iframeModal) {
                    const iframe = iframeModal.querySelector("iframe");
                    if (iframe) {
                        iframe.setAttribute("src", element.getAttribute("href") || "");
                        e.preventDefault();
                    }
                }
            });
        });
        $(".reset-floorplans").on('click', function () {
            ils.viewModel.BedroomMin(null);
            ils.viewModel.BedroomMax(null);
            ils.viewModel.PriceMin(null);
            ils.viewModel.PriceMax(null);
            var sliderElement = $("#uxPriceRangeSlider");
            if (sliderElement.length > 0) {
                sliderElement.slider("values", [sliderElement.slider("option", "min"), sliderElement.slider("option", "max")]);
                // We do not want to adjust handle margins if there is only one possible value
                var handle = sliderElement.find(".ui-slider-handle");
                const min = handle.attr("aria-valuemin");
                const max = handle.attr("aria-valuemax");
                if (min !== max) {
                    handle.removeClass("on-top");
                }
                sliderElement.find(".handle-text:first").html("$" + sliderElement.slider("option", "min"));
                sliderElement.find(".handle-text:last").html("$" + sliderElement.slider("option", "max"));
            }
            priceSliderUpdateFilter(sliderElement);
            sliderElement = $("#uxBedroomRangeSlider");
            if (sliderElement.length > 0) {
                sliderElement.slider("values", [sliderElement.slider("option", "min"), sliderElement.slider("option", "max")]);
                // We do not want to adjust handle margins if there is only one possible value
                var handle = sliderElement.find(".ui-slider-handle");
                const min = handle.attr("aria-valuemin");
                const max = handle.attr("aria-valuemax");
                if (min !== max) {
                    handle.removeClass("on-top");
                }
                sliderElement.find(".handle-text:first").html(FormatBedroomText(sliderElement.slider("option", "min")));
                sliderElement.find(".handle-text:last").html(FormatBedroomText(sliderElement.slider("option", "max")));
            }
            bedroomSliderUpdateFilter(sliderElement);
            FixHeightsAfterImagesLoaded($("#floorplans"));
            return false;
        });
        $(".read-more").on('click', function () {
            if (!readMoreClicked) {
                ils.trackCDPClickEvent({
                    communityId: ils.communityId,
                    communityName: ils.communityName,
                    communityUrl: ils.communityUrl,
                    clickTypeId: ClickType.Details,
                    clickType: "Read More"
                });
                //ga('send', 'event', 'CDPMoreInformation', 'click', globalThis.currentURL);
            }
            readMoreClicked = true;
        });
        $(".favorite").on('click', function () {
            if (!loggedIn) {
                parent.$("#uxExtraAction").val(`Favorited:${globalThis.showcaseItemID}`);
                return;
            }
            $(this).toggleClass("on");
            if ($(this).hasClass("on"))
                $(".trash").removeClass("on");
            $.ajax({
                type: 'POST',
                url: globalThis.baseUrl + "TftServices/MyFolder/MyFolderWebMethods.asmx/ToggleFavorite",
                data: `{ showcaseItemID: "${globalThis.showcaseItemID}", favorited: "${$(this).hasClass("on")}"}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            });
        });
        $(".trash").on('click', function () {
            if (!loggedIn) {
                parent.$("#uxExtraAction").val(`Trashed:${globalThis.showcaseItemID}`);
                return;
            }
            $(this).toggleClass("on");
            if ($(this).hasClass("on"))
                $(".favorite").removeClass("on");
            $.ajax({
                type: 'POST',
                url: globalThis.baseUrl + "TftServices/MyFolder/MyFolderWebMethods.asmx/ToggleTrash",
                data: `{ showcaseItemID: "${globalThis.showcaseItemID}", trashed: "${$(this).hasClass("on")}"}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            });
        });
        window.addEventListener('scroll', function (e) {
            if (isAutoScrolling === true) {
                return;
            }
            setTabFromScrollPosition();
        });
        //maps.initializeNeighborhoodMap();
        //maps.initializeMap();
        if (!ils.floorPlanLoaded) {
            var floorPlanTimeout = setTimeout(function () {
                BindPriceSlider();
                BindBedroomSlider();
                ils.floorPlanLoaded = true;
                FixHeightsAfterImagesLoaded($("#floorplans"));
                clearTimeout(floorPlanTimeout);
            }, 1000);
        }
        setTabFromScrollPosition();
        var positionTimeout = setTimeout(function () {
            // Now check to see if we have a URL fragment pointing to a different 
            var url = document.location.toString();
            var scheduleTour = getQueryVariable("scheduleTour");
            if (url.match('#') && !scheduleTour) {
                $('.cdp-menu a[href="#' + url.split('#')[1] + '"]').click();
            }
            else if (scheduleTour) {
                var scheduleTourTimeout = setTimeout(function () {
                    $(".schedule-tour").click();
                    clearTimeout(scheduleTourTimeout);
                }, 1000);
            }
            clearTimeout(positionTimeout);
        }, 500);
        ils.viewModel.GetInfoButtonsVisible(true);
    });
})(ils || (ils = {}));
